import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { AutomationsInput, PaginationInput } from '@/gql/graphql';
import automationKeys from './keyFactory';

const GetAutomations = graphql(`
  query Automations($input: AutomationsInput, $pagination: PaginationInput) {
    automations(input: $input, pagination: $pagination) {
      items {
        id
        privateId
        title
        entityType
        triggerEvent
        isActive
        updatedAt
        actions {
          __typename
        }
      }
      limit
      offset
      totalCount
    }
  }
`);

const useGetAutomations = (variables: {
  input?: AutomationsInput;
  pagination: PaginationInput;
}) => {
  const { data, ...rest } = useQuery({
    queryKey: automationKeys.automations(variables),
    queryFn: () => gqlClient.request(GetAutomations, variables),
    placeholderData: keepPreviousData,
  });
  return { automations: data?.automations, data, ...rest };
};

export default useGetAutomations;
